import React from 'react';

const BasicTick = ({ x, y, className, formatter = (value) => value, textAnchor, payload }) => (
    <g className={className} transform={`translate(${x}, ${y})`}>
        <text x={0} y={0} textAnchor={textAnchor}>
            {formatter(payload.value)}
        </text>
    </g>
);

export default BasicTick;
